// removed by extract-text-webpack-plugin
module.exports = {"take-action-share":"take-action-share___25vms center___2iqBf","take-action-label":"take-action-label___1mKr1","take-action-icons":"take-action-icons___3IFxV center___2iqBf","scorecard-methodology-link":"scorecard-methodology-link___1dveb h3___5u0xZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PlanScorecardToActionCenter/PlanScorecardToActionCenter.css
// module id = 914
// module chunks = 0